import { ChangeDetectionStrategy, Component } from "@angular/core";
import { LookerMemberManagementDashboardType } from "../../looker-member-management-dashboard-type.enum";
import { HideFilters } from "../../models/analytics-hide-filters.enum";

@Component({
  selector: "app-member-status-roster",
  templateUrl: "./member-status-roster.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MemberStatusRosterComponent {
filters: string[] = ["Projects"];
dashboardType = LookerMemberManagementDashboardType.Member_Status_Roster;
hideFilters: string[] = [HideFilters.PROJECT_ID, HideFilters.USER_ID, HideFilters.ORG_ID, "Customer_Name"];
}
